<!-- 企业信息 -->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Head>
          <template v-slot:title>
            <span style="margin-left:30%;">企业管理</span>
          </template>
        </Head>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" style="margin-top:20px;">
      <el-col :span="16">
        <el-card class="box-card">
          <div class="text item">
            <el-row>
              <el-col :span="5">
                <el-input
                    placeholder="请输入企业名称"
                    v-model="enterprise">
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
              </el-col>
              <el-col :span="19">
                <el-button style="margin-left: 20px" type="primary theme-btn" class="btn" @click.native="searchRole">
                  查询
                </el-button>
                <el-button type="info" class="btn" @click.native="reset">重置</el-button>
              </el-col>
            </el-row>
            <!-- 表格 -->
            <el-table style="width: 100%" :data="EnterpriseeData" class="table-content">
              <el-table-column label="编号" type="index"></el-table-column>
              <el-table-column label="企业名称" show-overflow-tooltip align="center" prop="name"></el-table-column>
              <el-table-column label="企业类型" show-overflow-tooltip align="center" prop="companyNature"></el-table-column>
              <el-table-column label="企业地址" show-overflow-tooltip align="center"
                               prop="companyAddress"></el-table-column>
              <el-table-column label="时间" align="center" prop="createTime"></el-table-column>
              <el-table-column label="企业状态" align="center" :formatter="formatSatus" prop="status"></el-table-column>

              <el-table-column label="操作" align="center" width="210">
                <template slot-scope="scope">
                  <el-button size="mini" @click="todetails(scope.row)" class="table-compile">详情</el-button>
                  <el-button v-show="roleid==1" v-if="scope.row.status == 1" size="mini" @click="block(scope.row,2)"
                             type="danger"
                             class="table-compile">拉黑
                  </el-button>
                  <el-button v-show="roleid == 1" v-if="scope.row.status == 2" size="mini" @click="Enable(scope.row,1)"
                             type="primary"
                             class="table-compile">启用
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagelist" style="text-align: center" v-if="pagegtion">
            <el-row type="flex" justify="center">
              <el-col :span="24" class="nomore" style="margin-top:24px;">
                <el-pagination
                    class="page"
                    background
                    :current-page="currentPage"
                    @current-change="current_page"
                    layout="total, prev, pager, next, jumper"
                    :total="dataNumber">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </el-card>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import Head from '@/components/header/head.vue';

export default {
  name: "company",
  components: {
    Head,
  },
  data() {
    return {
      page: 1,
      size: 10,
      EnterpriseeData: [],
      currentPage: 1,
      dataNumber: 0,
      enterprise: "", // 企业名称
      pagegtion: true,
      roleid: "",
      companyId: ""
    }
  },
  created() {
    var user = sessionStorage.getItem('userInfo')
    user = JSON.parse(user)
    this.roleid = user.roleId
    this.companyId = user.companyId
    if (this.roleid != 1) {
      this.getLibrary(this.page, this.size, this.enterprise, this.companyId)
    } else {
      this.getLibrary(this.page, this.size, this.enterprise)

    }
    // if (localStorage.getItem('roleId') != 1) {
    //   this.companyId = localStorage.getItem('companyId')
    // }

  },
  mounted() {
  },
  methods: {
    // 启用
    Enable(val, type) {
      this.axiosPost('/company/forbidden', {
        id: val.id,
        status: type,
      }).then((res) => {
        if (res.code == 200) {
          this.$confirm('此操作将启用该企业, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$message({
              type: 'success',
              message: '启用成功!'
            });
            if (this.roleid != 1) {
              this.getLibrary(this.page, this.size, this.enterprise, this.companyId)
            } else {
              this.getLibrary(this.page, this.size, this.enterprise)

            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消启用'
            });
          });
        }
      })
    },
    // 拉黑
    block(val, type) {
      this.axiosPost('/company/forbidden', {
        id: val.id,
        status: type,
      }).then((res) => {
        if (res.code == 200) {
          this.$confirm('此操作将拉黑该企业, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$message({
              type: 'success',
              message: '拉黑成功!'
            });
            if (this.roleid != 1) {
              this.getLibrary(this.page, this.size, this.enterprise, this.companyId)
            } else {
              this.getLibrary(this.page, this.size, this.enterprise)

            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消拉黑'
            });
          });
        }
      })
    },
    // 企业状态文字修改
    formatSatus(row, column) {
      if (row.status == 2) {
        return '拉黑'
      } else {
        return '启用'
      }
    },
    // 重置搜索数据
    reset() {

      this.enterprise = ""
      this.currentPage = 1
      if (this.roleid != 1) {
        this.getLibrary(this.page, this.size, this.enterprise, this.companyId)
      } else {
        this.getLibrary(this.page, this.size, this.enterprise)
      }
      this.pagegtion = false
      this.$nextTick(() => {
        this.pagegtion = true
      })
    },
    // 查询
    searchRole() {
      var user = sessionStorage.getItem('userInfo')
      user = JSON.parse(user)
      this.roleid = user.roleId
      this.companyId = user.companyId
      if (this.roleid != 1) {
        this.getLibrary(this.page, this.size, this.enterprise, this.companyId)
      } else {
        this.getLibrary(this.page, this.size, this.enterprise)
      }
    },
    // 获取企业库
    getLibrary(page, size, name, company) {
      this.axiosGet('/company/search', {
        params: {
          page: page,
          size: size,
          name: name,
          id: company,
          approveStatus: 2,
        }
      }).then((res) => {
        if (res.code == 200) {
          this.EnterpriseeData = res.data.list
          this.dataNumber = res.data.total
        }
      })
    },
    //分页
    current_page(currentPage) {
      this.page = currentPage
      this.getLibrary(this.page, this.size, this.enterprise)
    },
    // 跳转企业详情
    todetails(val) {
      this.$router.push({
        path: '/Businessdetails',
        query: {
          params: JSON.stringify(val.id)
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.newsList-box {
  width: 100%;

  .newsItemBox {
    transition: .2s;
    padding-left: 30px;
    display: flex;
    justify-content: space-between;

    .title-Top {
      line-height: 60px;
      color: black;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 220px;

    }

    .companyNature {
      line-height: 60px;
      color: black;
      width: 100px;
      text-align: center;
    }

    .BelongingContent {
      line-height: 60px;
      width: 120px;
      color: black;
      text-align: center;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .updateTime {
      line-height: 60px;
    }

    .content-bottom {
      line-height: 60px;
      margin-right: 30px;
    }
  }

  .newsItemBox:hover {
    box-shadow: 0px 3px 19px 5px rgba(42, 112, 255, 0.13);
  }
}

// 分页
.box-card {
  .box-top {
    padding: 36px 32px 0 30px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;

    .sendNewsBtn {
      width: 136px;
      height: 48px;
      border: 2px solid #1A80FC;
      border-radius: 8px;
      background: #fff;
      color: #1A80FC;
    }
  }

}


</style>
